"use client";

import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePathname } from "next/navigation";
import { useState } from "react";
import Socials from "../Socials/Socials";

const MainMenu = ({
  main_menu,
  top_menu,
  setShowMenuExpanded,
  settings,
}) => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [showSubTopMenu, setShowSubTopMenu] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(false);
  const [activeSubTopMenu, setActiveSubTopMenu] = useState(false);
  const path = usePathname();

  const email = settings?.options?.email;
  const phone = settings?.options?.telefoonnummer;
  const main_has_items = main_menu && main_menu.length > 0;

  return (
    <>
      <div
        className="fixed left-0 right-0 top-32 bottom-0 z-[100] cursor-pointer !border-t-0"
        onClick={() => setShowMenuExpanded(false)}
        aria-hidden
      />
      <div className="fixed left-0 right-0 top-32 bottom-0 z-[101] bg-white flex flex-col border-none !border-t-0">
        <div className="flex-1 overflow-y-auto">
          <div className="w-full px-4 py-5 mx-auto max-w-app">
            {(!showSubMenu && !showSubTopMenu) && (
              <div className="flex flex-col gap-10">
                <div className="flex flex-col divide-y divide-body">
                  {main_has_items && (
                    <div className="pb-6">
                      <div className="mb-3 text-sm font-bold text-dark-text">Assortiment</div>

                      <div className="flex flex-col gap-3">
                        {main_menu?.map((item, idx) => {
                          const { children, slug, title, url } = item || {};
                          const hasChildren = children?.length > 0;

                          const active_menu = slug == path;

                          const active_submenu = children?.some(
                            (child) => child?.slug == path
                          );

                          return (
                            <div
                              key={item?.term_id ?? `parent-${item?.slug ?? Math.random()}`}
                              className="flex items-center justify-between"
                            >
                              <a
                                title={title}
                                href={url}
                                className={`flex-1 text-sm leading-7 text-left no-underline text-dark-text ${(active_menu || active_submenu) && "font-bold"}`}
                                onClick={(e) => {
                                  if (hasChildren) {
                                    e.preventDefault();

                                    setShowSubMenu(true);
                                    setActiveSubmenu(idx);
                                  } else if (item?.slug) {
                                    setShowSubMenu(false);
                                    setActiveSubmenu(false);
                                  }
                                }}
                              >
                                {title}
                              </a>
                              {hasChildren && (
                                <FontAwesomeIcon
                                  icon={faChevronRight}
                                  className="text-sm cursor-pointer text-dark-text"
                                  onClick={(e) => {
                                    e.preventDefault();

                                    setActiveSubmenu(idx);
                                    setShowSubMenu(!showSubMenu);
                                  }}
                                  aria-hidden
                                />
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {top_menu?.length > 0 && top_menu && (
                    <div className={main_has_items ? "pt-6" : ""}>
                      <div className="flex flex-col gap-3">
                        {(top_menu ?? []).map((item, idx) => {
                          const { title, url, children } = item || {};
                          const has_children = children && children.length > 0;

                          return (
                            <a
                              key={item?.ID ?? `top-${item?.slug ?? item?.url ?? Math.random()}`}
                              title={title}
                              href={url}
                              className="flex items-center justify-between w-full text-sm leading-7 text-left no-underline text-dark-text"
                              onClick={(e) => {
                                if (has_children) {
                                  e.preventDefault();

                                  setShowSubTopMenu(true);
                                  setActiveSubTopMenu(idx);
                                } else if (item?.slug) {
                                  setShowSubTopMenu(false);
                                  setActiveSubTopMenu(false);
                                }
                              }}
                            >
                              <span>{title}</span>
                              {has_children && (
                                <FontAwesomeIcon
                                  icon={faChevronRight}
                                  className="text-sm text-dark-text"
                                  aria-hidden
                                />
                              )}
                            </a>
                          )
                        })}
                      </div>
                    </div>
                  )}
                </div>

                <Socials email={email} phone={phone} />
              </div>
            )}

            {showSubMenu && (
              <>
                <button
                  type="button"
                  className="inline-flex items-center gap-2 mb-4 text-sm text-dark-text"
                  onClick={() => {
                    setShowSubMenu(false);
                    setActiveSubmenu(false);
                  }}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                  <span>Terug</span>
                </button>

                {main_menu[activeSubmenu]?.children?.map((child, idx) => {
                  const { slug, url, title, ID } = child || {};
                  const active_child = slug == path;

                  return (
                    <a
                      key={ID ?? `child-${idx}`}
                      title={title}
                      href={url}
                      className={`block py-2 text-sm no-underline cursor-pointer text-dark-text ${active_child ? 'font-bold' : ''}`}
                    >
                      {title}
                    </a>
                  )
                })}
              </>
            )}

            {showSubTopMenu && (
              <>
                <button
                  type="button"
                  className="inline-flex items-center gap-2 mb-4 text-sm text-dark-text"
                  onClick={() => {
                    setShowSubTopMenu(false);
                    setActiveSubTopMenu(false);
                  }}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                  <span>Terug</span>
                </button>

                {top_menu[activeSubTopMenu]?.children?.map((child, idx) => {
                  const { slug, url, title, ID } = child || {};
                  const active_child = slug == path;

                  return (
                    <a
                      key={ID ?? `top-child-${idx}`}
                      title={title}
                      href={url}
                      className={`block py-2 text-sm no-underline cursor-pointer text-dark-text ${active_child ? 'font-bold' : ''}`}
                    >
                      {title}
                    </a>
                  )
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MainMenu;
